import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-remove-user-confirm',
  templateUrl: './remove-user-confirm-dialog.component.html',
  styleUrls: ['./remove-user-confirm-dialog.component.scss'],
})
export class RemoveUserConfirmDialogComponent {
  username: string;

  constructor(public dialogRef: MatDialogRef<RemoveUserConfirmDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.username = this.data.username;
  }

  ngOnInit() {}

  cancelDialog() {
    this.dialogRef.close(false);
  }

  confirmDialog() {
    this.dialogRef.close(true);
  }
}
